import { render, staticRenderFns } from "./AuthMenubar.vue?vue&type=template&id=0ae3738b&scoped=true"
import script from "./AuthMenubar.vue?vue&type=script&lang=js"
export * from "./AuthMenubar.vue?vue&type=script&lang=js"
import style0 from "./AuthMenubar.vue?vue&type=style&index=0&id=0ae3738b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae3738b",
  null
  
)

export default component.exports